import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntMonthPickerComponent} from "./int-month-picker.component";
import {IntLabeledFieldBoxModule} from "../../boxes";
import {ReactiveFormsModule} from "@angular/forms";
import {IntPortalSlotModule} from "../../../modules";
import {IntNativeElementModule} from "../../../directives";
import {IntDropdownAreaModule} from "../../dropdowns";
import {IntMonthCalendarModule} from "../../calendars";
import {IntClearActionDefaultModule} from "../../chanks";

@NgModule({
  imports: [
    CommonModule,
    IntMonthCalendarModule,
    IntLabeledFieldBoxModule,
    ReactiveFormsModule,
    IntPortalSlotModule,
    IntNativeElementModule,
    IntDropdownAreaModule,
    IntClearActionDefaultModule
  ],
  declarations: [
    IntMonthPickerComponent
  ],
  exports: [
    IntMonthPickerComponent
  ]
})
export class IntMonthPickerModule {}
